import { render, staticRenderFns } from "./SatisfactionChart.vue?vue&type=template&id=97566e64&scoped=true"
import script from "./SatisfactionChart.vue?vue&type=script&lang=js"
export * from "./SatisfactionChart.vue?vue&type=script&lang=js"
import style0 from "./SatisfactionChart.vue?vue&type=style&index=0&id=97566e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97566e64",
  null
  
)

export default component.exports